const ITEMS = [
  "FCA & PRA Alignment",
  "Regulatory Onsite Preparation",
  "Anti-Money Laundering",
  "Senior Managers & Certification Regime",
  "Cross-Border Governance",
  "Financial Crime Advisory",
  "Consumer Duty",
  "Operational Resilience",
];

const Strip = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="px-8 font-mono-alt text-xs sm:text-sm uppercase tracking-[0.3em] text-white/70 whitespace-nowrap">
          {item}
        </span>
        <span className="w-1.5 h-1.5 rotate-45 bg-[#a8824f] shrink-0" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div data-testid="editorial-marquee" className="py-6 bg-[#1b2a4e] overflow-hidden">
      <div className="flex w-max animate-marquee">
        <Strip />
        <Strip />
      </div>
    </div>
  );
}
